import { put, takeLatest } from 'redux-saga/effects';
import instance from 'src/sagas/set';
import { ReviewActionCreators } from 'src/store/reducers/feedback/action-creators';
import { ReviewActionEnum } from 'src/store/reducers/feedback/types';

function* fetchUpdateReview({
  currentReview,
  id
}: ReturnType<typeof ReviewActionCreators.updateReview>) {
  try {
    const { status }: Response = yield instance.patch(`feedback/${id}`, currentReview);
    yield put(ReviewActionCreators.resultUpdateReview(status));
  } catch (e) {
    console.log(e);
  }
}

export function* actionWatcherUpdateReview() {
  yield takeLatest(ReviewActionEnum.REQUEST_UPDATE_REVIEW, fetchUpdateReview);
}
